import { Grid } from '@material-ui/core';
import CustomMaskedInput from 'components/MaskedInput';
import React from 'react';

import { useStyles } from './styles';

interface IProps {
  label: string;
  fullWidth?: boolean;
  disableUnderline?: boolean;
  id: string;
  mask: 'phone' | 'creditCard' | 'monthYear' | 'cpfCnpj' | 'postalCode' | 'number' | 'money' | 'singledigit' | 'percent';
  helperText: string;
  error: boolean;
  value: string;
  onChange: (value: any) => void;
  shrink?: any;
  endAdornment?: string;
}

const Input = ({
  label,
  fullWidth = true,
  disableUnderline = true,
  id,
  mask,
  helperText,
  error,
  value,
  onChange,
  shrink = true,
  endAdornment = 'cm',
}: IProps) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} className={classes.container}>
      <CustomMaskedInput
        label={label}
        fullWidth={fullWidth}
        disableUnderline={disableUnderline}
        id={id}
        mask={mask}
        helperText={helperText}
        error={error}
        value={value}
        onChange={onChange}
        InputLabelProps={{
          shrink,
        }}
        endAdornment={endAdornment}
      />
    </Grid>
  );
};

export default Input;
